import { tw } from "../../styling";
import { Text } from "./text";

type Props = {
	children: React.ReactNode;
	bold?: boolean;
} & Omit<React.HTMLAttributes<HTMLParagraphElement>, "color">;

export const P = ({ children, bold, className, ...rest }: Props) => {
	const defaultSize = tw("text-base");
	const defaultColor = tw("text-text-primary");
	return (
		<Text component="p" className={tw(defaultSize, defaultColor, className)} bold={bold} {...rest}>
			{children}
		</Text>
	);
};
